var Libphonenumber = libphonenumber;
export var PhoneNumberUtils = {
    isValidPhoneNumber: Libphonenumber.isValidPhoneNumber,
    parsePhoneNumber: Libphonenumber.parsePhoneNumber
};
